import React, { Component } from 'react';

import { StringUtils } from '../utils';
import { Routes as routes } from '../navigation';
import '../css/SignIn.css';

class PracticeStaff extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  renderPracticeStaff = (staffMembers) => {
    if (!staffMembers || staffMembers.length === 0) {
      return null
    }

    const staffRows = staffMembers.map((member) => {
      if (member.approved === true) {
        return this.renderPracticeStaffRow(member);
      }
    }).filter((member) => { return member });

    return <div className="basic-container">
      <div className="flex-container flex-container-column">
        <h4 style={{ marginBottom: 10 }}>Practice Staff</h4>

        { staffRows }
      </div>
    </div>
  }

  renderPracticeStaffRow = (member) => {
    if (!member) {
      return null;
    }

    const user = member.user_details && member.user_details[0] ? member.user_details[0] : {};
    const roleStyle = { color: 'grey', fontSize: 13, marginTop: -3 }

    if (!user.first_name || member.front_desk) {
      return null;
    }

    var allRolesText = '';
    var allRoles = [];

    allRoles.push(member.admin ? 'Admin' : '');
    allRoles.push(member.practice_manager ?  'Practice Manager' : '');
    allRoles.push(member.practice_owner ?  'Practice Owner' : '');
    allRoles.push(member.vet ?  'Veterinarian' : '');
    allRoles.push(member.behaviorist ?  'Behaviorist' : '');
    allRoles.push(member.tech ? 'Tech' : '');

    allRoles.forEach((roleText) => {
      if (allRolesText === '' && roleText !== '') {
        allRolesText = roleText;
      } else if (roleText !== '') {
        allRolesText = allRolesText + ' | ' + roleText;
      }
    })

    return <div key={user._id} className="flex-container flex-container-row flex-space-between" style={{ marginTop: 5, marginBottom: 5, alignItems: 'center' }}>
      <div className="flex-container flex-container-column">
        <div className="flex-container flex-container-column">
          <span>{ StringUtils.displayName(user) }</span>
          <span className="flex-container" style={roleStyle}>
            { allRolesText }
          </span>

        </div>
      </div>
      <div>
        <input  className="button-clear-blue"
                value="Details"
                type="submit"
                onClick={ () => {
                  const roles = {
                    roles_id: member.id,
                    practice_id: member.practice_id,
                    admin: member.admin,
                    practice_manager: member.practice_manager,
                    practice_owner: member.practice_owner,
                    vet: member.vet,
                    behaviorist: member.behaviorist,
                    tech: member.tech,
                  }
                  this.props.practiceActions.openPracticeStaffMemberDetails(this.props.token, user._id, roles)
                }}
              />
      </div>
    </div>
  }

  render() {

    const staffMembers = this.props.staff || [];

    return this.renderPracticeStaff(staffMembers);
  }

}


export default PracticeStaff
